import { shouldBlockParticipantsEnrolledInOtherStudies } from './shouldBlockParticipantsEnrolledInOtherStudies';

export default {
  shouldBlockParticipantsEnrolledInOtherStudies,
};
